import Ellipsis from './Ellipsis';
import './Ellipsis.less';

export default Ellipsis;
